export default __webpack_public_path__ + "media/images/icons_fc/chart2-52bd8a6664a8a9f5abe78e3e5fc4caa4.png";